<template>
    <div id="app">
        <Header />
        <div class="main-container" @click="hideNotifications">
            <Subheader />
            <router-view></router-view>
            <RecentlyOnlineMembers v-if="showRecentUsersList"></RecentlyOnlineMembers>
        </div>
        <Footer />
        <div id="dialog-root"></div>
    </div>
</template>

<script>
    const ThemeHelper = function() {
      const preloadTheme = href => {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.disabled = false;
        link.href = href;

        return new Promise((resolve, reject) => {
          link.onload = function() {
            // Remove the onload() event listener after initial load, because some
            // browsers (like Firefox) could call onload() later again when changing
            // the link.disabled value.
            link.onload = null;
            link.disabled = true;
            resolve(link);
          };
          link.onerror = event => {
            link.onerror = null;
            reject(event);
          };
          document.head.appendChild(link);
        });
      };

      const selectTheme = (themes, name) => {
        if (name && !themes[name]) {
            throw new Error(`"${name}" has not been defined as a theme.`);
        }
        Object.keys(themes).forEach(n => {
          if (n !== name && !themes[n].disabled) themes[n].disabled = true;
        });
        if (themes[name].disabled) themes[name].disabled = false;
      };

      let themes = {};

      return {
        add(name, href) {
          return preloadTheme(href).then(s => (themes[name] = s));
        },
        set theme(name) {
            try{
                selectTheme(themes, name);
            }
            catch{
                setTimeout((name, href) => {
                    return preloadTheme(href).then(s => (themes[name] = s));
                }, 1000);
            }
        },
        get theme() {
          return Object.keys(themes).find(n => !themes[n].disabled);
        }
      };
    };


    import Header from './components/Layout/Header.vue'
    import Subheader from './components/Layout/Subheader.vue'
    import Footer from './components/Layout/Footer.vue'
    import RecentlyOnlineMembers from './components/Member/RecentlyOnlineMembers';

    export default {
        name: 'app',
        components: {
            Header,
            Subheader,
            Footer,
            RecentlyOnlineMembers
        },
        data() {
            return {
                themes: {
                  white: "/styles/theme-white.css",
                  blue: "/styles/theme-blue.css",
                  dark: "/styles/theme-dark.css",
                },
                themeHelper: new ThemeHelper(),
            };
        },
        computed: {
            showRecentUsersList() {
                return true;
            }
        },
        created() {
          if((!this.$store.getters.user || !this.$store.getters.user.displayName ) && localStorage.getItem('token')){
            this.$store.dispatch('getUserData');
          }

          this.unsubscribe = this.$store.subscribe((mutation, state) => {
              if(mutation.type === 'authSuccess' && state && state.auth && state.auth.auth && state.auth.auth.user && state.auth.auth.user.settings) {
                  const setting = state.auth.auth.user.settings.filter(r => r.settingName === 'Theme');
                  const val = setting[0].settingValue;
                  if( val ) {
                    localStorage.setItem('theme', val);
                    this.refreshTheme();
                  }
              }
          });
          let added = Object.keys(this.themes).map(name => {
            return this.themeHelper.add(name, this.themes[name]);
          });
          Promise.all(added).then(() => {
            this.loading = false;
            this.refreshTheme();
          });
          setInterval(() => {
            if (this.$store.getters.user.isMember()) {
                this.$store.dispatch('notifications/getNotificationNumber');
            }
          }, 30000);
        },
        methods: {
          hideNotifications() {
            if(this.$store.getters['notifications/shouldShowNotifications']){
              this.$store.dispatch('notifications/hideNotifications');
            }
          },
          refreshTheme() {
              const theme = localStorage.getItem('theme');
              if(!theme) {
                this.themeHelper.theme = "blue";
              }
              else{
                    if(theme === 'dark') {
                        this.themeHelper.theme = "dark";
                    }
                    if(theme === 'blue') {
                        this.themeHelper.theme = "blue";
                    }
                    else if(theme === 'white') {
                        this.themeHelper.theme = "white";
                    }
              }
          }
        },
        beforeDestroy() {
          this.unsubscribe();
        },
    };
</script>
